import { FINANCE, LEASING, SALES, VerticalType } from '@rma/common-ui-domain/types';

export type MapMarkerType = 'Review' | 'CompletedListing' | 'ActiveListing';
export type MapMarkerTypeIcon = 'review' | 'default' | 'label';
export type MapMarkerStatus = 'primary' | 'standard' | 'active' | 'viewed';

export const MAP_MARKER_ICON = {
  Review: 'review',
  CompletedListing: 'label',
  ActiveListing: 'default',
} as const satisfies Record<MapMarkerType, MapMarkerTypeIcon>;

export const MAP_TYPES = {
  [SALES]: ['Review', 'CompletedListing', 'ActiveListing'],
  [LEASING]: ['Review', 'ActiveListing'],
  [FINANCE]: ['Review'],
} as const satisfies Record<VerticalType, Readonly<MapMarkerType[]>>;
